import { LoadingButton, loadingButtonClasses } from '@mui/lab';
import { buttonBaseClasses } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { alpha, spacing as spacing$1 } from '@mui/system';
import { shouldNotForwardProps, withUtility, spacing } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26;
const Button = styled(LoadingButton, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  white-space: nowrap;
  font-size: 16px;
  font-weight: 700;

  ${0}

  ${0}

  ${0}

  ${0}

  ${0};

  ${0};
`), withUtility(({}, {
  iconOnly
}) => css(_t2 || (_t2 = _`
      padding-left: ${0};
      padding-right: ${0};
    `), iconOnly ? spacing(2) : spacing(6), iconOnly ? spacing(2) : spacing(6))), withUtility(({}, {
  fullWidth
}) => {
  if (!fullWidth) {
    return;
  }
  return css(_t3 || (_t3 = _`
      width: 100%;
    `));
}), withUtility(({}, {
  size,
  iconOnly
}) => {
  if (!iconOnly) {
    return;
  }
  switch (true) {
    case size === 'small':
      return css(_t4 || (_t4 = _`
          min-width: 32px;
          max-width: 32px;
        `));
    case size === 'medium':
      return css(_t5 || (_t5 = _`
          min-width: 48px;
          max-width: 48px;
        `));
    case size === 'large':
      return css(_t6 || (_t6 = _`
          min-width: 56px;
          max-width: 56px;
        `));
  }
  return;
}), withUtility(({}, {
  size,
  iconOnly
}) => {
  switch (true) {
    case size === 'small':
      return css(_t7 || (_t7 = _`
          height: ${0};
        `), iconOnly ? '32px' : '40px');
    case size === 'medium':
      return css(_t8 || (_t8 = _`
          height: 48px;
        `));
    case size === 'large':
      return css(_t9 || (_t9 = _`
          height: 56px;
        `));
    default:
      return css(_t10 || (_t10 = _``));
  }
}), withUtility(({
  palette,
  isLight
}, {
  variant,
  loading,
  disabled,
  hierarchy,
  inverted: isInverted
}) => {
  const theme = isLight ? 'light' : 'dark';
  const inverted = isInverted ? 'inverted' : 'default';
  if (variant === 'text' && isInverted) {
    return css(_t11 || (_t11 = _`
          color: ${0};

          &:hover {
            background-color: ${0};
          }
        `), palette('onPrimary'), alpha(palette('onPrimary'), 0.12));
  }
  if (variant === 'outlined' && isInverted) {
    return css(_t12 || (_t12 = _`
          border: 1px solid ${0};
          color: ${0};

          &:hover {
            border: 1px solid ${0};
            background-color: ${0};
          }
        `), palette('onPrimary'), palette('onPrimary'), palette('onPrimary'), alpha(palette('onPrimary'), 0.12));
  }
  /** ----------------------------------------------------------------------
   *
   * @Filled variant
   *
   * ---------------------------------------------------------------------- */
  if (variant === 'filled') {
    switch (true) {
      case loading || disabled:
        {
          const color = isInverted ? 'surface' : 'onSurface';
          return css(_t13 || (_t13 = _`
              &.${0} {
                color: ${0};
                border: 1px solid ${0};
                background-color: ${0};
              }

              &.${0} {
                color: transparent;
              }
            `), buttonBaseClasses.disabled, alpha(palette(color), 0.38), alpha(palette(color), 0.38), alpha(palette(color), 0.12), loadingButtonClasses.loading);
        }
      case hierarchy === 'primary':
        {
          const properties = {
            light: {
              default: {
                background: 'primaryContainer',
                color: 'onPrimaryContainer',
                border: 'onPrimaryContainer',
                backgroundHover: 'primaryContainer',
                overlayHover: 'onPrimaryContainer'
              },
              inverted: {
                background: 'primary',
                color: 'primaryContainer',
                border: 'primaryContainer',
                backgroundHover: 'primary',
                overlayHover: 'primaryContainer'
              }
            },
            dark: {
              default: {
                background: 'onPrimaryContainer',
                color: 'onPrimary',
                border: 'onPrimary',
                backgroundHover: 'onPrimaryContainer',
                overlayHover: 'onPrimary'
              },
              inverted: {
                background: 'primaryContainer',
                color: 'onPrimaryContainer',
                border: 'onPrimaryContainer',
                backgroundHover: 'primaryContainer',
                overlayHover: 'onPrimaryContainer'
              }
            }
          };
          const {
            background,
            color,
            border,
            backgroundHover,
            overlayHover
          } = properties[theme][inverted];
          return css(_t14 || (_t14 = _`
              background-color: ${0};
              color: ${0};
              border: 1px solid ${0};

              &:hover {
                background-color: ${0};

                & .MuiTouchRipple-root {
                  background-color: ${0};
                  opacity: 0.08;
                }
              }
            `), palette(background), palette(color), palette(border), palette(backgroundHover), palette(overlayHover));
        }
      case hierarchy === 'secondary':
        {
          const properties = {
            light: {
              default: {
                background: 'onBackground',
                color: 'onPrimary',
                border: 'onPrimary',
                backgroundHover: 'onBackground',
                overlayHover: 'onPrimary'
              },
              inverted: {
                background: 'onPrimaryContainer',
                color: 'primaryContainer',
                border: 'primaryContainer',
                backgroundHover: 'onPrimaryContainer',
                overlayHover: 'primaryContainer'
              }
            },
            dark: {
              default: {
                background: 'surfaceVariant',
                color: 'onSurface',
                border: 'onSurfaceVariant',
                backgroundHover: 'surfaceVariant',
                overlayHover: 'onSurface'
              },
              inverted: {
                background: 'onPrimary',
                color: 'onPrimaryContainer',
                border: 'onPrimaryContainer',
                backgroundHover: 'onPrimary',
                overlayHover: 'onPrimaryContainer'
              }
            }
          };
          const {
            background,
            color,
            border,
            backgroundHover,
            overlayHover
          } = properties[theme][inverted];
          return css(_t15 || (_t15 = _`
              background-color: ${0};
              color: ${0};
              border: 1px solid ${0};

              &:hover {
                background-color: ${0};

                & .MuiTouchRipple-root {
                  background-color: ${0};
                  opacity: 0.08;
                }
              }
            `), palette(background), palette(color), palette(border), palette(backgroundHover), palette(overlayHover));
        }
      case hierarchy === 'negative':
        {
          const properties = {
            light: {
              default: {
                background: 'errorContainer',
                color: 'onErrorContainer',
                border: 'onErrorContainer',
                backgroundHover: 'errorContainer',
                overlayHover: 'onErrorContainer'
              },
              inverted: {
                background: 'onErrorContainer',
                color: 'errorContainer',
                border: 'errorContainer',
                backgroundHover: 'onErrorContainer',
                overlayHover: 'errorContainer'
              }
            },
            dark: {
              default: {
                background: 'onError',
                color: 'error',
                border: 'error',
                backgroundHover: 'onError',
                overlayHover: 'error'
              },
              inverted: {
                background: 'onError',
                color: 'error',
                border: 'error',
                backgroundHover: 'onError',
                overlayHover: 'error'
              }
            }
          };
          const {
            background,
            color,
            border,
            backgroundHover,
            overlayHover
          } = properties[theme][inverted];
          return css(_t16 || (_t16 = _`
              background-color: ${0};
              color: ${0};
              border: 1px solid ${0};

              &:hover {
                background-color: ${0};

                & .MuiTouchRipple-root {
                  background-color: ${0};
                  opacity: 0.08;
                }
              }
            `), palette(background), palette(color), palette(border), palette(backgroundHover), palette(overlayHover));
        }
      default:
        return css(_t17 || (_t17 = _``));
    }
  }
  /** ----------------------------------------------------------------------
   *
   * @Outlined variant
   *
   * ---------------------------------------------------------------------- */
  if (variant === 'outlined') {
    switch (true) {
      case hierarchy === 'primary':
        {
          const properties = {
            light: {
              color: 'onPrimaryContainer',
              border: 'onPrimaryContainer',
              backgroundHover: 'onPrimaryContainer'
            },
            dark: {
              color: 'primary',
              border: 'primary',
              backgroundHover: 'primary'
            }
          };
          const {
            color,
            border,
            backgroundHover
          } = properties[theme];
          return css(_t18 || (_t18 = _`
              color: ${0};
              border: 1px solid ${0};

              &:hover {
                background-color: ${0};
                border: 1px solid ${0};

                & .MuiTouchRipple-root {
                  background-color: ${0};
                  opacity: 0.08;
                }
              }
            `), palette(color), palette(border), alpha(palette(backgroundHover), 0.12), palette(border), palette(backgroundHover));
        }
      case hierarchy === 'secondary':
        {
          const properties = {
            light: {
              color: 'onPrimaryContainer',
              border: 'onPrimaryContainer',
              backgroundHover: 'onPrimaryContainer'
            },
            dark: {
              color: 'onSurface',
              border: 'onSurfaceVariant',
              backgroundHover: 'onSurfaceVariant'
            }
          };
          const {
            color,
            border,
            backgroundHover
          } = properties[theme];
          return css(_t19 || (_t19 = _`
              color: ${0};
              border: 1px solid ${0};

              &:hover {
                background-color: ${0};
                border: 1px solid ${0};

                & .MuiTouchRipple-root {
                  background-color: ${0};
                  opacity: 0.08;
                }
              }
            `), palette(color), palette(border), alpha(palette(backgroundHover), 0.12), palette(border), palette(backgroundHover));
        }
      case hierarchy === 'negative':
        {
          const properties = {
            light: {
              color: 'onErrorContainer',
              border: 'onErrorContainer',
              backgroundHover: 'onErrorContainer'
            },
            dark: {
              color: 'error',
              border: 'error',
              backgroundHover: 'error'
            }
          };
          const {
            color,
            border,
            backgroundHover
          } = properties[theme];
          return css(_t20 || (_t20 = _`
              color: ${0};
              border: 1px solid ${0};

              &:hover {
                background-color: ${0};
                border: 1px solid ${0};

                & .MuiTouchRipple-root {
                  background-color: ${0};
                  opacity: 0.08;
                }
              }
            `), palette(color), palette(border), alpha(palette(backgroundHover), 0.12), palette(border), palette(backgroundHover));
        }
      default:
        return css(_t21 || (_t21 = _``));
    }
  }
  /** ----------------------------------------------------------------------
   *
   * @Text variant
   *
   * ---------------------------------------------------------------------- */
  if (variant === 'text') {
    switch (true) {
      case hierarchy === 'primary':
        {
          const properties = {
            light: {
              color: 'onPrimaryContainer',
              backgroundHover: 'onPrimaryContainer'
            },
            dark: {
              color: 'primary',
              backgroundHover: 'primary'
            }
          };
          const {
            color,
            backgroundHover
          } = properties[theme];
          return css(_t22 || (_t22 = _`
              color: ${0};

              &:hover {
                background-color: ${0};
              }
            `), palette(color), alpha(palette(backgroundHover), 0.04));
        }
      case hierarchy === 'secondary':
        {
          const properties = {
            light: {
              color: 'primary',
              backgroundHover: 'onPrimaryContainer'
            },
            dark: {
              color: 'onSurface',
              backgroundHover: 'onSurfaceVariant'
            }
          };
          const {
            color,
            backgroundHover
          } = properties[theme];
          return css(_t23 || (_t23 = _`
              color: ${0};

              &:hover {
                background-color: ${0};
              }
            `), palette(color), alpha(palette(backgroundHover), 0.04));
        }
      case hierarchy === 'negative':
        {
          const properties = {
            light: {
              color: 'error',
              backgroundHover: 'error'
            },
            dark: {
              color: 'error',
              backgroundHover: 'error'
            }
          };
          const {
            color,
            backgroundHover
          } = properties[theme];
          return css(_t24 || (_t24 = _`
              color: ${0};

              &:hover {
                background-color: ${0};
              }
            `), palette(color), alpha(palette(backgroundHover), 0.04));
        }
      default:
        return css(_t25 || (_t25 = _``));
    }
  }
  return css(_t26 || (_t26 = _``));
}), spacing$1);
Button.defaultProps = {
  variant: 'filled',
  hierarchy: 'primary'
};

export { Button };
